import React, { useCallback, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { serviceGetHealthTips } from "../../../../../services/HealthTips.service";
import history from "../../../../../libs/history.utils";
import RouteName from "../../../../../routes/Route.name";

const useProductHealthTipsTable = () => {
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [totalShow, setTotalShow] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
        serviceGetHealthTips({
        index: 1,
        program_id: id,
      }).then((res) => {
        if (!res.error) {
          const resData = res?.data;
          setAllData(resData);
          setData(resData);
        }
      });
    }
  }, [id]);

  useEffect(() => {
    // initData();
    _processData();
  }, [currentPage, data]);

  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  const queryFilter = useCallback((key, value) => {
    console.log("_queryFilter", key, value);
  }, []);

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  const handleEdit = useCallback((data) => {
    history.push(RouteName.HEALTH_UPDATE + data?.id);
  }, []);

  return {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    data,
    currentData,
    currentPage,
    isFetching,
    handleEdit
  };
};

export default useProductHealthTipsTable;
